export default (theme) => ({
  centerAll: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dropZone: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 3,
    width: "100%",
  },
  dropZoneInner: {
    width: "70%",
    height: 100,
    border: "2px dotted grey",
    borderRadius: 5,
    backgroundColor: "#f5f5f5",
    padding: "10px 20px",
    marginBottom: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
  uploadButtons: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginTop: 5,
  },
});
